import { render } from "./CommentSearch.vue?vue&type=template&id=44aac6bb"
import script from "./CommentSearch.vue?vue&type=script&lang=js"
export * from "./CommentSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__